import React, { FunctionComponent } from 'react';
import ReactDOM from 'react-dom';

type ReactPortalProps = {
  children: React.ReactNode;
  node?: Element | DocumentFragment;
};

const ReactPortal: FunctionComponent<ReactPortalProps> = ({
  children,
  node,
}) => {
  const [defaultNode, _] = React.useState<Element | DocumentFragment>(
    node ? node : document.createElement('div'),
  );

  if (
    !(
      typeof window !== 'undefined' &&
      window.document &&
      !!window.document.createElement
    )
  ) {
    return null;
  }

  if (!node) {
    document.body.appendChild(defaultNode);
  }

  return ReactDOM.createPortal(children, node || defaultNode);
};

export default ReactPortal;
